/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  Snackbar,
  Alert,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ technologies, brands, details }) {
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [is_deleted, setIsDeleted] = useState(details.is_deleted);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [loader, setLoader] = useState(false);
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (name, description, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/plate_inventory/brand/${details.id}`,
        {
          name,
          description,
          is_deleted,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        navigate("/dashboard/inventory/view-brands", {
          state: { success: true, message: "Brand Updated Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };
  return (
    <>
      <Formik
        initialValues={{
          name: details.name,
          description: details.description,
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Brand Name is required"),
          description: Yup.string().required("Description is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values.name, values.description, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Brand Updated Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update Brand
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="name"
                          value={values.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.name && errors.name)}
                          id="search-field"
                          label="Brand Name"
                          helperText={touched.name && errors.name}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          name="description"
                          fullWidth
                          value={values.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(
                            touched.description && errors.description
                          )}
                          id="search-field"
                          label="Description"
                          helperText={touched.description && errors.description}
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} md={3}>
                        <FormControl
                          fullWidth
                          component="fieldset"
                          variant="standard"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) => setIsDeleted(e.target.checked)}
                                checked={is_deleted}
                              />
                            }
                            label={"IS DELETED"}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Update
                        </Button>
                        {/* <Button
                        style={{ textAlign: "center", background: "red" }}
                        mr={2}
                        variant="contained"
                        color="primary"
                      >
                        Reset
                      </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}



function UpdateBrand() {
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState({
    name: location.state?.name,
    description: location.state?.description,
    id: location.state?.id,
    is_deleted: location.state?.is_deleted,
  });
  useEffect(() => {
    // getBrandDetails(setDetails, brand_id, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE BRAND
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory/view-brands">
                View Brands
              </Link>
              <Typography>Update Brand</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails details={details} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default UpdateBrand;
